import React, { createContext, useContext, useState, useMemo } from 'react';

// Create context
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  function toggleSidebar() {
    /* CONSOL */
    console.log("toggle")
    setIsSidebarOpen(!isSidebarOpen);
  }

  function closeSidebar() {
    console.log("close")
    setIsSidebarOpen(false);
  }

  const value = useMemo(
    () => ({
      isSidebarOpen,
      toggleSidebar,
      closeSidebar,
    }),
    [isSidebarOpen]
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

// Now you can use the SidebarContext in your components
// For example:
/*
import { useContext } from 'react';
import { SidebarContext } from 'path/to/SidebarContext';

const MyComponent = () => {
  const { isSidebarOpen, toggleSidebar, closeSidebar } = useContext(SidebarContext);

  // Now you can use isSidebarOpen, toggleSidebar, and closeSidebar
};
*/

export default SidebarProvider;
